<script>
	export default {
		props: {
			items: Array,
		},

		computed: {
			// an array of items which are faqs.
			faqs() {
				return this.items.filter(item => item.is_faq > 0);
			},

			// an array of items matching the requested term
			matchingTerm() {
			    if (!this.initiated) {
			        return [];
                }
				return this.items.filter(item => item['question' + this.$root._lng].indexOf(this.term) >= 0).slice(0, 12);
			}
		},

		data() {
			return {
				initiated: false,
				term: '',
				selectedItem: 0
			}
		},

		mounted() {
			this.initiated = true;
		},

		methods: {
			setSelected(id) {
				this.selectedItem = id;
				this.term = '';
			},
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/QAndAs.vue